/** Mirrors the quality API's tenant roles; platform actions remain separately protected. */
export function canAccessQuality(roles: readonly string[]) {
  return roles.some(role => ['admin', 'owner', 'developer', 'quality_analyst', 'privacy_officer'].includes(role));
}
export function canEnrichCompany(roles: readonly string[]) {
  return roles.some(role => ['admin', 'owner', 'developer', 'analyst', 'sales'].includes(role));
}
